import { useField } from "formik"
import { Password } from "primereact/password"
import { useTranslation } from "react-i18next"

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%&/\\()?¿*\-+=^,;.:_{}[\]]).{8,}$/

const MEDIUM_REGEX =
  /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})./

const FormikPassword = ({
  id,
  autoFocus,
  feedback,
  onChange,
  className,
  ...props
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()

  const [field, meta] = useField(props)

  const errorMsg = meta.error && meta.touched ? meta.error : ""

  const TemplatePasswordHeader = <h6>{t("signUpForm.password.title")}</h6>

  const TemplatePassword = (
    <>
      <ul
        className='p-pl-2 p-ml-2 p-mt-0'
        style={{ lineHeight: "1.5" }}
      >
        <li>{t("signUpForm.password.lowerCase")}</li>
        <li>{t("signUpForm.password.capitalLetter")}</li>
        <li>{t("signUpForm.password.oneNumber")}</li>
        <li>{t("signUpForm.password.minimumEight")}</li>
        <li>{t("signUpForm.password.specialCharacter")}</li>
      </ul>
    </>
  )

  return (
    <>
      {/* @ts-expect-error TS(2769): No overload matches this call. */}
      <Password
        id={id}
        toggleMask
        feedback={feedback}
        autoFocus={autoFocus}
        header={TemplatePasswordHeader}
        footer={TemplatePassword}
        mediumRegex={MEDIUM_REGEX}
        strongRegex={PASSWORD_REGEX}
        weakLabel={t("signUpForm.password.weak")}
        mediumLabel={t("signUpForm.password.medium")}
        strongLabel={t("signUpForm.password.strong")}
        className={className}
        inputClassName={className}
        {...field}
        onChange={onChange || field.onChange}
      />
      {errorMsg && <small className='p-error p-d-block'>{errorMsg}</small>}
    </>
  )
}

export default FormikPassword
